import { c as _c } from "react/compiler-runtime";
import type React from "react";
import { cn } from "@/lib/utils";
export interface AddressData {
  firstName: string;
  lastName: string;
  phone: string;
  address: string;
  addressDetail?: string;
  province: string;
  city: string;
  zipCode: string;
}
export interface AddressDisplayProps {
  data: AddressData;
  variant?: "default" | "compact" | "card";
  layout?: "vertical" | "horizontal";
  showPhone?: boolean;
  showFullName?: boolean;
  className?: string;
  nameClassName?: string;
  phoneClassName?: string;
  addressClassName?: string;
  province: string;
  formatLocation?: (city: string, province: string, zipCode: string) => string | {
    line1: string;
    line2?: string;
  };
}
export const AddressDisplay: React.FC<AddressDisplayProps> = t0 => {
  const $ = _c(49);
  const {
    data,
    variant: t1,
    layout: t2,
    showPhone: t3,
    showFullName: t4,
    className,
    nameClassName,
    phoneClassName,
    addressClassName,
    province,
    formatLocation
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const layout = t2 === undefined ? "vertical" : t2;
  const showPhone = t3 === undefined ? true : t3;
  const showFullName = t4 === undefined ? true : t4;
  const {
    firstName,
    lastName,
    phone,
    address,
    addressDetail,
    city,
    zipCode
  } = data;
  const maskPhone = _temp;
  let t5;
  if ($[0] !== city || $[1] !== formatLocation || $[2] !== province || $[3] !== zipCode) {
    t5 = formatLocation ? formatLocation(city, province, zipCode) : `${city} ${province} ${zipCode}`;
    $[0] = city;
    $[1] = formatLocation;
    $[2] = province;
    $[3] = zipCode;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const locationResult = t5;
  let renderLocation;
  let t10;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] !== address || $[6] !== addressClassName || $[7] !== addressDetail || $[8] !== className || $[9] !== firstName || $[10] !== lastName || $[11] !== layout || $[12] !== locationResult || $[13] !== nameClassName || $[14] !== phone || $[15] !== phoneClassName || $[16] !== showFullName || $[17] !== showPhone || $[18] !== variant) {
    t10 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const variants = {
        default: {
          container: "space-y-2",
          name: "font-['DINPro-Medium'] font-medium text-[#111] text-base md:text-lg leading-none",
          phone: "text-[#999] font-['DINPro-Regular'] font-normal text-base leading-none",
          address: "text-[#111] font-['DINPro-Regular'] font-normal text-sm md:text-base break-words"
        },
        compact: {
          container: "space-y-1",
          name: "font-['DINPro'] text-xs text-[#010101]",
          phone: "font-['DINPro'] text-xs text-[#010101]",
          address: "font-['DINPro'] text-xs text-[#010101] break-words"
        },
        card: {
          container: "space-y-1",
          name: "font-['DINPro-Bold'] text-gray-900 text-base",
          phone: "text-sm text-gray-600 font-['DINPro-Regular']",
          address: "text-sm text-gray-600 font-['DINPro-Regular'] leading-relaxed break-all"
        }
      };
      const styles = variants[variant];
      let t11;
      if ($[25] !== locationResult) {
        t11 = () => {
          if (typeof locationResult === "string") {
            return <div>{locationResult}</div>;
          }
          if (typeof locationResult === "object") {
            return <><div>{locationResult.line1}</div>{locationResult.line2 && <div>{locationResult.line2}</div>}</>;
          }
          return null;
        };
        $[25] = locationResult;
        $[26] = t11;
      } else {
        t11 = $[26];
      }
      renderLocation = t11;
      if (variant === "compact" && layout === "horizontal") {
        const t12 = cn(styles.container, className);
        const t13 = showFullName && <span className={cn(styles.name, "whitespace-nowrap", nameClassName)}>{lastName} {firstName}</span>;
        const t14 = showPhone && <span className={cn(styles.phone, "whitespace-nowrap", phoneClassName)}>{maskPhone(phone)}</span>;
        let t15;
        if ($[27] !== t13 || $[28] !== t14) {
          t15 = <div className="flex items-start gap-3">{t13}{t14}</div>;
          $[27] = t13;
          $[28] = t14;
          $[29] = t15;
        } else {
          t15 = $[29];
        }
        const t16 = cn(styles.address, addressClassName);
        const t17 = addressDetail && ` ${addressDetail}`;
        let t18;
        if ($[30] !== address || $[31] !== t17) {
          t18 = <div>{address}{t17}</div>;
          $[30] = address;
          $[31] = t17;
          $[32] = t18;
        } else {
          t18 = $[32];
        }
        let t19;
        if ($[33] !== renderLocation) {
          t19 = renderLocation();
          $[33] = renderLocation;
          $[34] = t19;
        } else {
          t19 = $[34];
        }
        t10 = <div className={t12}>{t15}<div className={t16}>{t18}{t19}</div></div>;
        break bb0;
      }
      t7 = cn(styles.container, className);
      t8 = showFullName && <div className={cn(styles.name, nameClassName)}>{lastName} {firstName}</div>;
      t9 = showPhone && <div className={cn(styles.phone, phoneClassName)}>{maskPhone(phone)}</div>;
      t6 = cn(styles.address, addressClassName);
    }
    $[5] = address;
    $[6] = addressClassName;
    $[7] = addressDetail;
    $[8] = className;
    $[9] = firstName;
    $[10] = lastName;
    $[11] = layout;
    $[12] = locationResult;
    $[13] = nameClassName;
    $[14] = phone;
    $[15] = phoneClassName;
    $[16] = showFullName;
    $[17] = showPhone;
    $[18] = variant;
    $[19] = renderLocation;
    $[20] = t10;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    renderLocation = $[19];
    t10 = $[20];
    t6 = $[21];
    t7 = $[22];
    t8 = $[23];
    t9 = $[24];
  }
  if (t10 !== Symbol.for("react.early_return_sentinel")) {
    return t10;
  }
  const t11 = addressDetail && ` ${addressDetail}`;
  let t12;
  if ($[35] !== address || $[36] !== t11) {
    t12 = <div>{address}{t11}</div>;
    $[35] = address;
    $[36] = t11;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== renderLocation) {
    t13 = renderLocation();
    $[38] = renderLocation;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[40] !== t12 || $[41] !== t13 || $[42] !== t6) {
    t14 = <div className={t6}>{t12}{t13}</div>;
    $[40] = t12;
    $[41] = t13;
    $[42] = t6;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  let t15;
  if ($[44] !== t14 || $[45] !== t7 || $[46] !== t8 || $[47] !== t9) {
    t15 = <div className={t7}>{t8}{t9}{t14}</div>;
    $[44] = t14;
    $[45] = t7;
    $[46] = t8;
    $[47] = t9;
    $[48] = t15;
  } else {
    t15 = $[48];
  }
  return t15;
};
function _temp(phoneNumber) {
  if (!phoneNumber || phoneNumber.length < 4) {
    return phoneNumber;
  }
  const lastFour = phoneNumber.slice(-4);
  const maskedPart = "*".repeat(phoneNumber.length - 4);
  return maskedPart + lastFour;
}